import React from "react";
import * as Lucide from "lucide-react";

/** Render a Lucide icon by string name with a graceful fallback. */
export default function LucideIconByName({ name, className, color, strokeWidth }) {
  const Icon = (name && Lucide[name]) || Lucide.MessageSquare;
  return <Icon className={className} color={color} strokeWidth={strokeWidth} />;
}
